const $ = window.$;
export function loadTree() {
  const trees = $('[data-widget="treeview"]');
  trees.Treeview('init', {
    accordion: true,     
    animationSpeed: 300,
    expandIcon: 'fas fa-angle-left',
    collapseIcon: 'fas fa-angle-down',
    triggerElement: '.nav-link',
    activeClass: 'menu-open',  
  });
}